import styled from 'styled-components';

export const Container = styled.div`
  width: 50px;
  display: inline-flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
  margin: 10px;
  h5 {
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    line-height: normal;
    margin-top: 10px;
    margin-bottom: 0;
  }
`;

export default Container;
